import React from 'react';
import SideNavBar from "../SideNavBar";
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import CommunicationHub from '../CommunicationHub';

const CommunicationHubPage = () => {
  return (
    <div>
      <React.Fragment>
    <SideNavBar>
       <CommunicationHub />
    </SideNavBar>
  </React.Fragment>
    </div>
  );
}

export default NetworkDetector(CommunicationHubPage);
